import React from 'react';
import PropTypes from 'prop-types';
import 'nvd3/build/nv.d3.css';

export default function Header({ title }) {
  return (
    <div className="pie-chart-header" tabIndex={0}>
      {title}
    </div>
  );
}

Header.propTypes = {
  title: PropTypes.string,
};
